import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setReschedulingFromPositionAction = (
  state: PlanboardState,
  action: PayloadAction<{ machineId: number; fromIndex: number; correlationId: string }>
) => {
  const { machineId, fromIndex, correlationId } = action.payload;
  if (!state.reschedulingFromPosition[machineId]) {
    state.reschedulingFromPosition[machineId] = [];
  }
  state.reschedulingFromPosition[machineId].push({ fromIndex, correlationId });
};
